import { isNil } from "lodash";
import { useMemo } from "react";

import { MAX_PAGE_SIZE } from "./constants";

/**
 * Creates an options object that is used in the API query to the retrieve email suppression data.
 *
 * @param date The date range of results to retrieve
 * @param page The page of results to retrieve
 * @param email A possible email to search for
 * @param searchMethod The method to use for searching the given email ('exact' or 'contains')
 * @param defaultDate The default date range if the selected date is null
 * @return The options object to be used in the query. The object has format:
 * {
 *   from: Date as number,
 *   to: Date as number,
 *   page: number,
 *   size: number,
 *   searchTerm: string | undefined
 *   searchMethod: string | undefined
 * }
 */
export const useQueryOptions = (date, page, email, searchMethod, defaultDate) =>
  useMemo(() => {
    let config = {};
    let dateRange = date;
    if (isNil(date)) {
      dateRange = defaultDate;
    }

    if (!isNil(dateRange)) {
      config.from = dateRange.startDate.valueOf();
      config.to = dateRange.endDate.valueOf();
    }
    config.page = page;
    config.size = MAX_PAGE_SIZE;
    if (email && email.length > 0) {
      config.searchTerm = email;
      config.searchMethod = searchMethod;
    }
    return config;
  }, [date, page, email, searchMethod, defaultDate]);
